<div class="bracket-round-container">
    <div class="bracket-round-title text-center">
        <span *ngIf="round.name !== 'FINALS'">{{ round.name }}</span>
        <span *ngIf="round.name === 'FINALS'" translate>TOURNAMENTS.FINALS</span>
    </div>
<div *ngFor="let m of round.matches; let i = index" class="bracket-match bracket-match-{{ round.roundNum }} {{ i === 0 && round.name === 'FINALS' ? 'first-finals' : i === round.matches.length - 1 ? 'match-last'  : ''}}">
    <div *ngIf="round.name !== 'FINALS'" class="{{ i === 0 ? 'first' : '' }}">
        <match [match]="m" [round]="round"></match>
    </div>
    <div *ngIf="round.name === 'FINALS' && m.roundRank === 1">
        <div class="bracket-round-third bracket-match-final" translate>TOURNAMENTS.FIRSTPLACEMATCH</div>
        <match [match]="m" [round]="round"></match>
    </div>
    <div *ngIf="round.name === 'FINALS' && m.roundRank === 2">
        <div class="bracket-round-third" translate>TOURNAMENTS.THIRDPLACEMATCH</div>
        <match [match]="m" [round]="round"></match>
    </div>
</div>
